import { createVoltraComponent } from './createVoltraComponent.js'
import type { DividerProps } from './props/Divider.js'

export type { DividerProps }
export const Divider = createVoltraComponent<DividerProps>('Divider')
